import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "@/utils/languageRouter";

// Localized Link component - automatically adds language prefix
const LocalizedLink = ({ to, children, ...props }) => {
  const { lang } = useParams();
  const currentLang = SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
  
  // If 'to' already starts with a language prefix, don't add another
  const hasLangPrefix = SUPPORTED_LANGUAGES.some(l => to.startsWith(`/${l}/`) || to === `/${l}`);
  
  // If it's an external link or anchor, don't modify
  if (to.startsWith("http") || to.startsWith("#") || to.startsWith("mailto:") || to.startsWith("tel:")) {
    return <RouterLink to={to} {...props}>{children}</RouterLink>;
  }
  
  // If it's an admin or collaborator route, don't add language prefix
  if (to.startsWith("/admin") || to.startsWith("/collaborator")) {
    return <RouterLink to={to} {...props}>{children}</RouterLink>;
  }
  
  // Build the localized path
  let localizedTo = to;
  if (!hasLangPrefix) {
    const cleanPath = to.startsWith("/") ? to : `/${to}`;
    localizedTo = `/${currentLang}${cleanPath}`;
  }
  
  return <RouterLink to={localizedTo} {...props}>{children}</RouterLink>;
};

export default LocalizedLink;
